window.APP = window.APP || {};
import jQuery from 'jquery';
import $ from 'jquery';
import dayjs from 'dayjs';

APP.bookingMenuTabs = (function ($) {
    'use strict';

    var BOOKING_MENU = '.booking-menu';
    var TAB_LINK = '.booking-menu-tabs__link';
    var TAB_BODY = '.booking-menu-tabs__body';
    var TAB_CHILD_FADE = 'fade-children';
    var ACTIVE_CLASS = 'is-active';
    var ACTIVE_SELECTOR = '.is-active';
    var AVAILABILITY_BTN = '.js-check-availability';
    var DISABLED_BTN_CLASS = 'js-disabled';

    var RESTAURANT_DROPDOWN_RESTAURANT = '.js-restaurant-booking-restaurant';
    var RESTAURANT_DROPDOWN_SITTING = '.js-restaurant-booking-sitting';
    var RESTAURANT_DROPDOWN_GUESTS = '.js-restaurant-booking-guests';
    var RESTAURANT_CHECK_AVAILABILIY = '.js-check-availability';

    var RESTAURANT_DATA_ENDPOINT = '/RestaurantBookingHeaderChecker/GetRestaurantData';
    var RESTAURANT_SUBMIT_URL = '/RestaurantBookingHeaderChecker/SubmitForm';

    var RESTAURANT_SIMPLECHECKER_BOOKABLE_DATES_ENDPOINT = '/RestaurantBookingSimpleChecker/GetBookableDates';

    var DINING_EXCEEDED_FUTURE = 'dining-date-exceededFuture';

    var UNAVAILABLE_CALENDAR_HOVER = 'This date cannot be selected';
    var AVAILABLE_CALENDAR_HOVER = 'Choose this date';

    var isDateSelected = false;

    var diningStartDate = new Date();
    var diningEndDate = new Date();

    var diningStartingDate = null;
    var diningBookingMaxDate = null;
    var diningisDateCappedByDayLimit = false;

    if (typeof window.validBookingPeriod !== 'undefined' && window.validBookingPeriod !== null) {
        diningEndDate.setDate(diningEndDate.getDate() + parseInt(window.validBookingPeriod, 10));
    } else {
        diningEndDate.setDate(diningEndDate.getDate() + 90);
        window.validBookingPeriod = 90;
    }

    var init = function () {
        $(document).ready(function () {
            $('body').on('click', TAB_LINK, onBookingTabClick);
            $('body').on('click', RESTAURANT_CHECK_AVAILABILIY, onCheckAvailability);

            initialiseFrenchRegion();
            initialiseCalendars();
            initialiseDiningDropdowns();

            checkForDefaultBookingTab();
            initUnselectableButtonClick();
            checkForSimpleChecker();

            $(TAB_LINK).matchHeight();


            if (typeof window.validBookingPeriodRawMessage != 'undefined') {
                window.validBookingPeriodMessage = window.validBookingPeriodRawMessage.replace("{0}", window.validBookingPeriod);
            }
        });
    };

    function checkForDefaultBookingTab() {
        if (typeof window.bookingMenuSelectedTab !== 'undefined') {
            showTab(window.bookingMenuSelectedTab, true);
        }
    }

    if (typeof window.availableDates === 'undefined') {
        window.availableDates = [true];
    }

    function initialiseFrenchRegion() {
        $.datepicker.regional['fr'] = {
            closeText: "Fermer",
            prevText: "Précédent",
            nextText: "Suivant",
            currentText: "Aujourd'hui",
            monthNames: ["janvier", "février", "mars", "avril", "mai", "juin",
                "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
            monthNamesShort: ["janv.", "févr.", "mars", "avr.", "mai", "juin",
                "juil.", "août", "sept.", "oct.", "nov.", "déc."],
            dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
            dayNamesShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
            dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
            weekHeader: "Sem.",
            dateFormat: "dd/mm/yy",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ""
        };
    }

    // To check availability we run an ajax method to return available dates
    // Update the window.availableDates array with the new dates
    // Refresh the calendar - $('#dining-date').datepicker('refresh');

    function initialiseCalendars() {

        if (window.preferredCulture == null || window.preferredCulture == '') {
            $.datepicker.setDefaults($.datepicker.regional['en']);
        } else {
            $.datepicker.setDefaults($.datepicker.regional[window.preferredCulture]);
        }

        $('#dining-date').datepicker({
            dateFormat: 'dd/mm/yy',
            minDate: diningStartDate,
            maxDate: diningEndDate,
            firstDay: 1,
            beforeShowDay: checkAvailableDates, // Comment to not filter dates,
            onSelect: function (selectedDate) {
                isDateSelected = true;
                checkForValidateBooking();
                var splitDate = selectedDate.split('/');
                var formattedDate = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
                APP.calendarAccessibility.createStatusMessage(formattedDate, null, 'diningreservation-booking__status-message', $('#dining-date').parent());
                setTimeout(function () {
                    APP.calendarAccessibility.initDateAttributes('dining-date');
                }, 50);
            },
            onChangeMonthYear: function (year, month, obj) {
                $("#BookingDiningTabContent .hasDatepicker").removeClass("datepicker-init");

                checkCalendarBounds(year, month, obj);
                setTimeout(function () {

                    if (!isDateSelected) {
                        $("#BookingDiningTabContent .ui-datepicker-current-day").removeClass("ui-datepicker-current-day");
                    }

                    setTimeout(event => {
                        $("#BookingDiningTabContent .hasDatepicker").addClass("datepicker-init");
                    }, 150)

                    APP.calendarAccessibility.initDateAttributes('dining-date');
                    APP.calendarAccessibility.setTabIndexes('dining-date');
                }, 10);
            }
        });

        const currentSelectedDate = document.querySelector('#BookingDiningTabContent .ui-datepicker-current-day');

        if (currentSelectedDate) {
            currentSelectedDate.classList.remove('ui-datepicker-current-day');
        }

        setTimeout(event => {
            $("#BookingDiningTabContent .hasDatepicker").addClass("datepicker-init");
        }, 150);

        // Remove currently selected date, feels a bit messy
        $('#dining-date').datepicker('setDate', null);
        $('#dining-date').find('a.ui-state-highlight.ui-state-active').removeClass('ui-state-highlight ui-state-active').parents('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
        APP.calendarAccessibility.initPresentationMode('dining-date');
        APP.calendarAccessibility.initDateAttributes('dining-date');
        APP.calendarAccessibility.initKeyboardNavigation('dining-date');
    }


    function getCalendarAmountToShow() {
        return (window.innerWidth > 1200) ? 2 : 1;
    }

    function checkMinMaxDates(minDate, maxDate) {
        var currentDate = new Date();
        currentDate.setHours(0);
        currentDate.setMinutes(0);
        currentDate.setSeconds(0);
        currentDate.setMilliseconds(0);

        if (minDate !== null) {
            var minDateObj = new dayjs.unix(minDate).toDate();

            // Only update the min date if it is in the future
            if (minDateObj > currentDate) {
                diningStartingDate = minDateObj;
                console.log('BookingRestriction: New minimum date set for ResDiary Booking', diningStartingDate);
            }
        } else {
            diningStartingDate = currentDate;
        }

        if (maxDate != null) {
            diningBookingMaxDate = new dayjs.unix(maxDate).toDate();
            if (diningBookingMaxDate < diningEndDate) {
                console.log("BookingRestriction: ResDiary max date is sooner than booking period max date")
                diningEndDate = diningBookingMaxDate;
                diningisDateCappedByDayLimit = false;
            } else {
                diningisDateCappedByDayLimit = true;
            }
        } else {
            diningisDateCappedByDayLimit = true;
        }

        console.log('BookingRestriction: New maximum date set for ResDiary Booking', diningEndDate);
    }

    function checkCalendarBounds(year, month, obj) {
        // Check to see whether the new date on the calendar is far in the future, if so show warning message
        // Timeout is to allow month to have updated in time
        setTimeout(function () {
            if (diningisDateCappedByDayLimit && year === diningEndDate.getFullYear() && month === diningEndDate.getMonth() + 1) {
                showValidBookingPeriodMessage(obj.dpDiv);
            } else {
                hideValidBookingPeriodMessage(obj.dpDiv);
            }
        }, 100);
    }

    function initUnselectableButtonClick() {
        $("body").on("click", ".booking-menu .ui-datepicker-unselectable", function () {
            APP.calendarAccessibility.createStatusMessage(null, null, 'diningreservation-booking__status-message', $('.room-booking__calendar'), true);
        })
    }

    // This function is to unbind the select2 scroll handlering when the select2 menu is open
    // to will allow the user to scroll the main page
    function updateSelect2ToAllowWindowScrolling(e) {
        const evt = "scroll.select2";
        $(e.target).parents().off(evt);
        $(window).off(evt);
    }

    function initialiseDiningDropdowns() {
        $(RESTAURANT_DROPDOWN_RESTAURANT).select2({
            dropdownParent: $(RESTAURANT_DROPDOWN_RESTAURANT).parents('.booking__select'),
            minimumResultsForSearch: -1,
            allowClear: false,
            placeholder: window.RestaurantDropdownFirstItem
        }).on('select2:open', function (e) {
            updateSelect2ToAllowWindowScrolling(e);
            const bookingTabs = $(".booking-menu-tabs__content")

            bookingTabs.each(function () {
                $(this).addClass("overflow-none")
            })
        }).on('select2:close', function (e) {
            const bookingTabs = $(".booking-menu-tabs__content")

            bookingTabs.each(function () {
                $(this).removeClass("overflow-none")
            })
        });

        const parentRestaurant = $(RESTAURANT_DROPDOWN_RESTAURANT).parent();
        if (parentRestaurant) {
            const labelIdRestaurant = parentRestaurant.find("label")[0];
            const singleSelectionRestaurant = parentRestaurant.find(".select2-selection--single");
    
            if (singleSelectionRestaurant && labelIdRestaurant) {
                singleSelectionRestaurant.first().attr("aria-labelledby", labelIdRestaurant.id)
            }
        }

        $(RESTAURANT_DROPDOWN_SITTING).select2({
            dropdownParent: $(RESTAURANT_DROPDOWN_SITTING).parents('.booking__select'),
            minimumResultsForSearch: -1,
            allowClear: true,
            placeholder: window.SittingDropdownFirstItem
        }).on('select2:open', function (e) {
            updateSelect2ToAllowWindowScrolling(e);

            const bookingTabs = $(".booking-menu-tabs__content")

            bookingTabs.each(function () {
                $(this).addClass("overflow-none")
            })
        }).on('select2:close', function (e) {
            const bookingTabs = $(".booking-menu-tabs__content")

            bookingTabs.each(function () {
                $(this).removeClass("overflow-none")
            })
        }).on('results:message', function () {
            this.dropdown._resizeDropdown();
            this.dropdown._positionDropdown();
        });

        const parentSittings = $(RESTAURANT_DROPDOWN_SITTING).parent();
        if (parentSittings) {
            const labelIdSittings = parentSittings.find("label")[0];
            const singleSelectionSittings = parentSittings.find(".select2-selection--single");
            
            if (singleSelectionSittings && labelIdSittings) {
                singleSelectionSittings.first().attr("aria-labelledby", labelIdSittings.id);
            }
        }

        $(RESTAURANT_DROPDOWN_GUESTS).select2({
            dropdownParent: $(RESTAURANT_DROPDOWN_GUESTS).parents('.booking__select'),
            minimumResultsForSearch: -1,
            allowClear: true,
            placeholder: window.GuestsDropdownFirstItem,
            dropdownCssClass: "booking__select-spa-guest"
        }).on('select2:open', function (e) {
            updateSelect2ToAllowWindowScrolling(e);

            const bookingTabs = $(".booking-menu-tabs__content")

            bookingTabs.each(function () {
                $(this).addClass("overflow-none")
            })
        }).on('select2:close', function (e) {
            const bookingTabs = $(".booking-menu-tabs__content")

            bookingTabs.each(function () {
                $(this).removeClass("overflow-none")
            })
        });

        const parentGuests = $(RESTAURANT_DROPDOWN_GUESTS).parent();
        if (parentGuests) {
            const labelIdGuest = parentGuests.find("label")[0];
            const singleSelectionGuest = parentGuests.find(".select2-selection--single");

            if (singleSelectionGuest && labelIdGuest) {
                singleSelectionGuest.first().attr("aria-labelledby", labelIdGuest.id);
            }
        }
       

        $(RESTAURANT_DROPDOWN_RESTAURANT).on('select2:select', function (e) {
            var data = e.params.data;

            if (data) {
                populatesittingOptions(data.id);
                checkForValidateBooking();
            }

            APP.calendarAccessibility.createStatusMessage(null, null, 'diningreservation-booking__status-message', $('.room-booking__calendar'));
        });

        $(RESTAURANT_DROPDOWN_SITTING).on('select2:select', function (e) {

            checkForValidateBooking();
            APP.calendarAccessibility.createStatusMessage(null, null, 'diningreservation-booking__status-message', $('.room-booking__calendar'));
        });

        $(RESTAURANT_DROPDOWN_GUESTS).on('select2:select', function (e) {

            if (!isDateSelected) {
                $("#BookingDiningTabContent .ui-datepicker-current-day").removeClass("ui-datepicker-current-day");
            }

            setTimeout(event => {
                $("#BookingDiningTabContent .hasDatepicker").addClass("datepicker-init");
            }, 150)

            checkForValidateBooking();
            APP.calendarAccessibility.createStatusMessage(null, null, 'diningreservation-booking__status-message', $('.room-booking__calendar'));
        });


        const restaurant = document.querySelector('[data-restaurant]');

        if (restaurant) {
            const attr = restaurant.getAttribute('data-restaurant');
            $(RESTAURANT_DROPDOWN_RESTAURANT).val(attr).trigger('change');;
        }

        // Check for prepopulated restaurant dropdown
        var restaurantSelection = $(RESTAURANT_DROPDOWN_RESTAURANT).val();
        if (typeof restaurantSelection !== 'undefined' && restaurantSelection !== '') {
            populatesittingOptions(restaurantSelection);
            checkForValidateBooking();
        }
    }

    function checkForValidateBooking() {

        // Get all selects for checker
        var errors = false;

        if (isDateSelected === false) {
            errors = true;
        } else {
            var $selects = $('.booking-menu-tabs__body.is-active select');

            // Loop through all selects and see if any are empty values, if so return out
            $selects.each(function () {
                var val = $(this).val();
                if (typeof val === 'undefined' || val === '') {
                    errors = true;
                    return false;
                }

            });
        }

        if (errors) {
            $(AVAILABILITY_BTN).addClass(DISABLED_BTN_CLASS).attr('disabled', true);
        } else {
            $(AVAILABILITY_BTN).removeClass(DISABLED_BTN_CLASS).removeAttr('disabled');
        }
    }

    function showValidBookingPeriodMessage($elem) {
        $elem.find('.ui-datepicker-header').each(function () {
            $(this).addClass(DINING_EXCEEDED_FUTURE).attr('data-validBookingPeriod', window.validBookingPeriodMessage);
        })

    }

    function hideValidBookingPeriodMessage($elem) {
        $elem.find('.ui-datepicker-header:last').removeClass(DINING_EXCEEDED_FUTURE);
    }

    function populatesittingOptions(restaurantID) {
        var dataParam = {
            'SelectedRestaurant': restaurantID,
            'language': window.preferredCulture
        };


        $.ajax({
            type: 'POST',
            url: RESTAURANT_DATA_ENDPOINT + "?language=" + window.preferredCulture,
            data: JSON.stringify(dataParam),
            dataType: 'json',
            contentType: 'application/json charset=utf-8',
            async: true,
            error: function (xhr, text, err) {
                console.error(xhr, text, err);
            },
            success: function (data, status, xhr) {
                parseRestaurantData(data);
            }
        });
    }

    function parseRestaurantData(data) {
        // Clear existing dropdowns
        $(RESTAURANT_DROPDOWN_SITTING).empty().trigger('change');
        $(RESTAURANT_DROPDOWN_GUESTS).empty().trigger('change');

        // Add sitting options
        for (var item in data.SittingOptions) {
            var opt = new Option(data.SittingOptions[item].Text, data.SittingOptions[item].Value, data.SittingOptions[item].Selected, data.SittingOptions[item].Selected);
            $(RESTAURANT_DROPDOWN_SITTING).append(opt);
        }
        $(RESTAURANT_DROPDOWN_SITTING).prop('disabled', false).trigger('change');

        if (data.SittingOptions.length === 0) {
            $(RESTAURANT_DROPDOWN_SITTING).next(".select2-container").hide();
            const label = $(RESTAURANT_DROPDOWN_SITTING).closest('div')[0];
            label.querySelector('label').classList.remove('d-md-inline-block');
            label.querySelector('label').classList.add('d-none');
            window.preselectedSitting = data.SelectedSitting;
        } else {
            $(RESTAURANT_DROPDOWN_SITTING).next(".select2-container").show();
            const label = $(RESTAURANT_DROPDOWN_SITTING).closest('div')[0];
            label.querySelector('label').classList.add('d-md-inline-block');
            label.querySelector('label').classList.remove('d-none');
        }


        // Updating Guests
        for (var item in data.GuestOptions) {
            var opt = new Option(data.GuestOptions[item].Text, data.GuestOptions[item].Value, data.GuestOptions[item].Selected, data.GuestOptions[item].Selected);
            $(RESTAURANT_DROPDOWN_GUESTS).append(opt);
        }
        $(RESTAURANT_DROPDOWN_GUESTS).prop('disabled', false).trigger('change');

        // Update booking dates
        if (typeof data.BookableDates === 'undefined') {
            //console.error('No bookable dates returned');
        } else {
            window.availableDates = data.BookableDates;
            $('#dining-date').datepicker('refresh');

            $("#BookingDiningTabContent .hasDatepicker").removeClass("datepicker-init");

            if (!isDateSelected) {
                $("#BookingDiningTabContent .ui-datepicker-current-day").removeClass("ui-datepicker-current-day");
            }

            setTimeout(event => {
                $("#BookingDiningTabContent .hasDatepicker").addClass("datepicker-init");
            }, 150)


            // Remove currently selected date, feels a bit messy
            $('#dining-date').datepicker('setDate', null);
            $('#dining-date').find('a.ui-state-highlight.ui-state-active').removeClass('ui-state-highlight ui-state-active').parents('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
            isDateSelected = false;
        }

        // Display additional text
        $('.js-additionaltext').html();
        var additionalMarkup = '';

        if (typeof data.MaximumTableSizeText !== 'undefined' && data.MaximumTableSizeText !== null) additionalMarkup += data.MaximumTableSizeText;
        if (typeof data.PrivateDiningText !== 'undefined' && data.PrivateDiningText !== null) additionalMarkup += data.PrivateDiningText;

        if (additionalMarkup !== '') {
            $('.js-additionaltext').html(additionalMarkup);
        }

        // Update Valid Booking Period
        if (typeof data.ValidBookingPeriod !== 'undefined' && typeof window.validBookingPeriodRawMessage !== 'undefined') {
            window.validBookingPeriod = data.ValidBookingPeriod;
            window.validBookingPeriodMessage = window.validBookingPeriodRawMessage.replace("{0}", data.ValidBookingPeriod);
            
            diningEndDate = new Date();
            diningEndDate.setDate(diningEndDate.getDate() + parseInt(window.validBookingPeriod, 10));
            
            checkMinMaxDates(data.MinimumRestaurantBookingDate, data.MaximumRestaurantBookingDate);

            $('#dining-date').datepicker('option', 'minDate', diningStartingDate);
            $('#dining-date').datepicker('option', 'maxDate', diningEndDate);
            $('#dining-date').datepicker('refresh');

            // Remove currently selected date, feels a bit messy
            $('#dining-date').datepicker('setDate', null);
            $('#dining-date').find('a.ui-state-highlight.ui-state-active').removeClass('ui-state-highlight ui-state-active').parents('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
            isDateSelected = false;
        }

        checkForValidateBooking();
    }

    function onCheckAvailability() {
        var restaurant = $(RESTAURANT_DROPDOWN_RESTAURANT).find(':selected').val();
        var sitting = $(RESTAURANT_DROPDOWN_SITTING).find(':selected').val();
        var guests = $(RESTAURANT_DROPDOWN_GUESTS).find(':selected').val();
        var date = $('#dining-date').datepicker('getDate');

        if (typeof sitting === 'undefined') {
            sitting = window.preselectedSitting;
        }

        var formatedDate = new Date(date);
        var strDate = formatedDate.getFullYear() + '-' + (formatedDate.getMonth() + 1) + '-' + formatedDate.getDate();

        window.location = RESTAURANT_SUBMIT_URL + '?SelectedRestaurant=' + restaurant + '&SelectedSitting=' + sitting + '&SelectedGuests=' + guests + '&SelectedDate=' + strDate + '&Language=' + window.preferredCulture;
    }

    function checkForSimpleChecker() {
        if ($('#availability_checker_form').length > 0) {
            getBookableDates($('#availability_checker_form #DesiredDate'));
        }
    }

    function getBookableDates($calendarElem) {
        $.ajax({
            type: 'POST',
            url: RESTAURANT_SIMPLECHECKER_BOOKABLE_DATES_ENDPOINT,
            dataType: 'json',
            contentType: 'application/json charset=utf-8',
            async: true,
            error: function (xhr, text, err) {
                console.error(xhr, text, err);
            },
            success: function (data, status, xhr) {
                if (typeof data.BookableDates == 'undefined') {
                    //console.error('No bookable dates returned');
                } else {
                    window.availableDates = data.BookableDates;
                    $calendarElem.datepicker('refresh');
                }
            }
        });
    }

    function checkAvailableDates(date) {
        if (availableDates[0] === true) { // If the first item is true show all dates
            return [true, "", AVAILABLE_CALENDAR_HOVER];
        } else if (availableDates[0] === false) {
            return [false, "", UNAVAILABLE_CALENDAR_HOVER];
        }

        var dmy = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
        if ($.inArray(dmy, availableDates) != -1) {
            return [true, "", AVAILABLE_CALENDAR_HOVER];
        } else {
            return [false, "", UNAVAILABLE_CALENDAR_HOVER];
        }
    }

    function onBookingTabClick(e) {
        e.preventDefault();

        var ind = $(this).index();
        showTab(ind);
    }

    var showTab = function (index, isOnload = false) {
        // Remove active classes
        $(TAB_LINK + ACTIVE_SELECTOR).removeClass(ACTIVE_CLASS).attr('aria-selected', 'false');
        $(TAB_BODY + ACTIVE_SELECTOR).removeClass(TAB_CHILD_FADE);
        $(TAB_BODY + ACTIVE_SELECTOR).removeClass(ACTIVE_CLASS).attr('aria-hidden', 'true');
        // Show single active tab
        $(TAB_LINK).eq(index).addClass(ACTIVE_CLASS).attr('aria-selected', 'true');
        if (!isOnload) $(TAB_BODY).eq(index).addClass(TAB_CHILD_FADE);
        $(TAB_BODY).eq(index).addClass(ACTIVE_CLASS).attr('aria-hidden', 'false');

    }

    return {
        init: init,
        showTab: showTab
    };

})(jQuery);


